import angular from 'angular';

import RwCopyrightComponent from './rw-copyright-component';
import { RwCopyrightController } from './rw-copyright-controller';

export default angular
  .module('rw-copyright', [])
  .controller('RwCopyrightController', RwCopyrightController)
  .component('rwCopyright', RwCopyrightComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-copyright/rw-copyright-module.js